import React, { forwardRef, useEffect, useState } from "react";
import Label from "../ui/Label";
import Card from "../ui/Card";
import VirtualTable from "../ui/VirtualTable";
import { ROUTES } from "../utils/Routes";
import Button from "../ui/Button";
import Float from "../ui/Float";
import { createModal } from "../hooks/createModal";
import ReportsFilterEdit from "./ReportsFilterEdit";
import ReportsFilterSelect from "./ReportsFilterSelect";
import { getEnum, getEnumLabel, kbdEvent, showConfirm, updateOrdering } from "../utils/Utils";
import { ENUMS } from "../utils/Enums";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { showError, showMessage } from "../ui/Message";
import { pubCall } from "../utils/PubSub";
const ReportFilter = forwardRef(function ReportFilter(props, ref) {

    const { controller = "", escape = () => { }, report = {}, height = 260, goto = () => { }, setReport = () => { }, where_type = "AND", edit = false, route = "", show_add = false, small = false, headerClass = "", showColumnHeaders = true, header = "",

        onFocus = () => { },
        onBlur = () => { },
        onClick = () => { },

        callback = () => {

        }

    } = props;

    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("start")
    const row_key = "filter_id";


    useEffect(() => {
        if (edit) {

            window.bm_state.value = ROUTES.REPORTS.FILTER
        }
    }, [edit])


    const [data, setData] = useState([]);


    useEffect(() => {
        setData(props.data);

        if (!selected?.[row_key] && props.data?.length) {
            setSelected(props.data[0]);
            return;
        }

        const newSelected = props.data.find(x => x?.[row_key] === selected?.[row_key]);

        if (newSelected) {
            setSelected(newSelected);
        } else if (props.data.length) {
            setSelected(props.data[props.data.length - 1]);
        }

    }, [props.data]);




    useEffect(() => {

        if (!edit) {
            return;
        }

        const actions = [
            { key: KBD.TAB, action: (e) => { callback(data, "next") } },
            { key: KBD.SHIFT_TAB, action: (e) => { callback(data, "prev") } },
            { key: KBD.ENTER, action: (e) => { callback(data, "next") } },
            { key: KBD.ESCAPE, action: (e) => { escape(false) } },
            { key: KBD.D, action: (e) => { removeFilter() } },
            { key: KBD.E, action: (e) => { drawEdit(selected, true) } },
            { key: KBD.N, action: (e) => { drawFilterSelect() } },
            { key: KBD.ALT_C, action: () => goto("columns") },
            { key: KBD.PAGE_DOWN, action: () => goto("save") }

        ];
        const cleanup = listen(controller, route, actions, () => { }, [KBD.TAB, KBD.ENTER, KBD.ESCAPE]);
        return cleanup;
    }, [edit, data, selected])


    const onDrop = (_filter, _target = where_type) => {

        const _filter_obj = JSON.parse(_filter.dataTransfer.getData("text/plain"));

        if (!_filter_obj?.item?.filter_id) {
            return;
        }

        if (_filter_obj?.type === where_type) {
            return;
        }

        // remove
        let _filters = report.filters.filter(item => item?.[row_key] !== _filter_obj?.item?.filter_id);
        // add to top
        _filters.push({ ..._filter_obj.item, "where_type": _target });
        _filters = updateOrdering(_filters);

        props.activate();
        pubCall("report.purgeAndReplaceFilters", { report_id: report.report_id, filters_info: _filters }, (_s, _r) => {
            if (_s) {
                setReport(_r);
                setSelected({ ..._filter_obj.item, "where_type": _target })
                showMessage("Filter moved")
            } else {
                showError(_r);
            }
        })



    }

    const replaceWithVals = (_arr, _e, _f) => {
        let _enum = getEnum(_arr, _e);

        if (!_enum) {
            return (<>Unknown: {_e}</>)
        }
        let _ret = _enum.label;

        Object.keys(_f).forEach(key => {
            if (_enum.hasOwnProperty(key)) {
                const searchValue = _enum[key];
                const replaceValue = `<strong style="color:#fff;font-weight: 700">${_f[key]}</strong>`;
                const escapedSearchValue = searchValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                _ret = _ret.replace(new RegExp(escapedSearchValue, ''), replaceValue); // Non-global replace
            }
        });

        return (<span dangerouslySetInnerHTML={{ __html: _ret }}></span>);
    };

    const removeFilter = () => {
        if (!selected?.[row_key]) { return; }


        showConfirm({
            controller: controller,
            route,
            description: (
                <div style={{ textAlign: "center", "width": "330px" }}>
                    Are you sure you wish to remove this filter?
                </div>
            ),
            title: "Remove Filter?",
            callback: confirmed => {
                if (confirmed) {
                    let _filters = report.filters.filter(item => item?.[row_key] !== selected?.[row_key]);
                    _filters = updateOrdering(_filters);
                    pubCall("report.purgeAndReplaceFilters", { report_id: report.report_id, filters_info: _filters }, (_s, _r) => {
                        if (_s) {
                            setReport(_r);
                            showMessage("Filter removed")
                        } else {
                            showError(_r);
                        }
                    })

                }
            }
        });




    }

    const columns = [
        // {
        //     key: "number", title: <></>, align: "left", width: 30, render : (e, f) => {
        //         return f.type.toString(); 
        //     }
        // },

        {
            key: "type", title: <>Filter</>, align: "left", grow: true, width: 300, render: (e, f) => {
                return (!small) ? <div onDragStart={(e) => {

                    setSelected(f);
                    e.dataTransfer.setData("text/plain", JSON.stringify({
                        item: f,
                        type: where_type,
                    }));


                }} draggable>{f.type.toString()}) {replaceWithVals(ENUMS.REPORT_FILTERS, e, f)}</div> : <span style={{ "fontSize": "14px" }}>{replaceWithVals(ENUMS.REPORT_FILTERS, e, f)}</span>
            }
        }
    ]

    if (edit) {
        columns.push(
            {
                key: "remove", title: <></>, align: "left", grow: false, width: 30, render: (e, f) => {
                    return (edit && selected?.[row_key] === f?.[row_key]) ? <div><Button onClick={() => kbdEvent(KBD.D)} className={"ui-tbl-btn"} style={{ "color": "#fff" }}>X</Button></div> : ""
                }
            }
        )

        columns.push(
            {
                key: "edit", title: <></>, align: "left", grow: false, width: 30, render: (e, f) => {


                    let _f = ENUMS.REPORT_FILTERS.find(item => item.value === f.type)
                    if (_f && !_f?.value_1) {
                        return (<></>)
                    }


                    return (edit && selected?.[row_key] === f?.[row_key]) ? <div><Button onClick={() => drawEdit(f, true)} className={"ui-tbl-btn"} style={{ "color": "#fff", "backgroundColor": "var(--text-green)" }}>✎</Button></div> : ""
                }
            }
        )
        columns.push(
            {
                key: "scroll", title: <></>, align: "left", grow: false, width: 9
            }
        )

    }

    const next = (_rows = 1) => {



        if (!data?.length || data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (!data?.length || data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };


    const drawEdit = (_filter, edit = false) => {


        let _f = ENUMS.REPORT_FILTERS.find(item => item.value === _filter?.type)
        if (_f && !_f?.value_1) {
            showError({error: "Filter has not configurable options"})
            return; 
        }

        window.bm_state.value = ROUTES.REPORTS.FILTER_EDIT;
        createModal({
            component: <ReportsFilterEdit controller={controller} filter={_filter} edit={edit} where_type={where_type} report={report} setReport={setReport} route={ROUTES.REPORTS.FILTER_EDIT} />, closable: true, title: <>{(edit) ? "Edit" : "Add"} Filter</>, callback: (_filter) => {

                if (_filter) {

                    callback(_filter)
                }

                window.bm_state.value = ROUTES.REPORTS.FILTER;
            }
        })
    }

    const drawFilterSelect = () => {
        window.bm_state.value = ROUTES.REPORTS.FILTER_SELECT;
        createModal({
            component: <ReportsFilterSelect controller={controller} route={ROUTES.REPORTS.FILTER_SELECT} />, closable: true, title: <>Add Filter</>, callback: (_filter) => {
                if (_filter && _filter?.active) {
                    drawEdit(_filter)
                } else {
                    window.bm_state.value = ROUTES.REPORTS.FILTER;
                }

            }
        })
    }

    return (
        <div onDrop={(e) => onDrop(e)} onDragOver={(e) => e.preventDefault()} style={{ "display": "flex", "flexDirection": "column", "height": (height) ? height + "px" : "100%" }} onBlur={() => onBlur()} onFocus={() => onFocus()} onClick={() => onFocus()} ref={ref} tabIndex={0} className={(edit) ? "ui-outline" : "no-focus"}>

            <VirtualTable
                controller={controller}
                edit={edit}
                small={small}
                scrollbar={true}
                showColumnHeaders={showColumnHeaders}
                header={<Float><Label className="light" style={{ "textAlign": "left" }}>{header}</Label>{(show_add && <a onClick={() => { setTimeout(() => { kbdEvent(KBD.N) }, 10) }} style={{ "fontSize": "14px" }}>Add Filter +</a>)}</Float>}
                headerClass={headerClass}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                onRowDoubleClick={(item) => drawEdit(item, true)}
                next={next}
                prev={prev}
                align={align}
                row_key={row_key}
                current={selected}
                data={data}
                columns={columns}
                width={0}
                loading={false}
                fullHeight={true}
                offset={0}
                height={150}
                route={(edit) ? ROUTES.REPORTS.FILTER : ""}
            />
        </div>
    )
});

export default ReportFilter;